export const CAMERA_ORIGINAL_PREFIX = 'PIC_';
